var map = {
	"./html": 401,
	"./html.js": 401,
	"./md": 402,
	"./md.js": 402
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/dist/isomorphic/wrappers ^\.\/.*$
// module id = 400
// module chunks = 0